import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    position: fixed;
    padding:0;
    margin:0;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    // height: calc(100vh);
    // min-width: 100vw; causes issue with TagPopOut
    cursor: pointer;
    z-index: ${props => props.zIndex || '100'};
    background-color: ${props => props.backgroundColor ? props.backgroundColor : 'var(--secondary-color)'};
    opacity: ${props => props.opacity ? props.opacity : '50%'};
    transform: ${props => props.tranform ? props.transform : null};
`

const Close = props => {
    const {
        style,
        zIndex,
    } = props;
    const backgroundColor = style ? style.backgroundColor : null
    const opacity = style ? style.opacity : null
    return (
        <Container {...props} backgroundColor={backgroundColor} opacity={opacity} zIndex={zIndex}/>
    )
}

export default Close